module.exports = __webpack_public_path__ + "item.variations-3ccfbe63.html";